import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    image = "image",
    linkTo = "linkTo",
    icon = "icon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.image]: string;
        [fields.icon]: string;
        [fields.linkTo]: {
            type: string;
            value: string;
        };
    };
}

interface HeaderIconLink {
    wrapper?: InjectableCss;
    iconContainer?: InjectableCss;
    title?: InjectableCss;
    image?: InjectableCss;
}

export const styles: HeaderIconLink = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            [class^="Wrapper"] {
                display: flex;
            }
        `,
    },
    iconContainer: {
        css: css`
            height: 40px;
        `,
    },
    title: {
        css: css`
            text-align: center;
            margin-bottom: 0;
            font-size: 14px;
            font-weight: 400;
            color: ${getColor("text.main")};
            margin-top: 1px;
        `,
    },
    image: {
        css: css`
            > img {
                width: 47px;
                height: 40px;
            }
        `,
    },
};

const HeaderIconLink: FC<OwnProps> = ({ fields }) => {
    const { linkTo, title, icon } = fields;
    return (
        <Link href={linkTo?.value}>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.iconContainer}>
                    <LazyImage src={icon} {...styles.image} altText={`${translate(`${title}img`)}`} />
                </StyledWrapper>
                <Typography variant="p" {...styles.title}>
                    {title}
                </Typography>
            </StyledWrapper>
        </Link>
    );
};

const widgetModule: WidgetModule = {
    component: HeaderIconLink,
    definition: {
        group: "Common",
        displayName: "HeaderIconLink",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
            },
            {
                fieldType: "General",
                name: fields.linkTo,
                displayName: "Link to",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.icon,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
